"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPageBreadcrumb = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PageBreadcrumbMixin = require("../../mixins/components/PageBreadcrumbMixin");
var _PageContent = require("../PageContent/PageContent");
var StyledPageBreadcrumb = /*#__PURE__*/(0, _styledComponents.default)(_PageContent.PageContent).withConfig({
  displayName: "StyledPageBreadcrumb",
  componentId: "c11n-8-107-0__sc-spmldi-0"
})(["", ""], _PageBreadcrumbMixin.PageBreadcrumbMixin);
exports.StyledPageBreadcrumb = StyledPageBreadcrumb;